/* GridSelectionModel.js */

/* globals Slick */

const $ = require("jquery");
class GridSelectionModel {
    constructor(options) {
        this._ranges = [];
        this._handler = new Slick.EventHandler();
        this._options = {
            selectActiveRow: true,
        };
        Object.assign(this._options, options);
        this.onSelectedRangesChanged = new Slick.Event();
    }

    init(grid) {
        this._grid = grid;
        this._handler.subscribe(
            this._grid.onActiveCellChanged,
            this.handleActiveCellChange.bind(this)
        );
        this._handler.subscribe(this._grid.onKeyDown, this.handleKeyDown.bind(this));
        this._handler.subscribe(this._grid.onClick, this.handleClick.bind(this));
    }

    destroy() {
        this._handler.unsubscribeAll();
        this._handler = null;
    }

    rangesToRows(ranges) {
        let rows = [];
        for (let i = 0; i < ranges.length; i++) {
            for (let j = ranges[i].fromRow; j <= ranges[i].toRow; j++) {
                rows.push(j);
            }
        }
        return rows;
    }

    rowsToRanges(rows) {
        let ranges = [];
        let lastCell = this._grid.getColumns().length - 1;
        for (let i = 0; i < rows.length; i++) {
            ranges.push(new Slick.Range(rows[i], 0, rows[i], lastCell));
        }
        return ranges;
    }

    getRowsRange(from, to) {
        let i,
            rows = [];
        for (i = from; i <= to; i++) {
            rows.push(i);
        }
        for (i = to; i < from; i++) {
            rows.push(i);
        }
        return rows;
    }

    getSelectedRows() {
        return this.rangesToRows(this._ranges);
    }

    setSelectedRows(rows, evt) {
        this.setSelectedRanges(this.rowsToRanges(rows), evt);
    }

    setSelectedRanges(ranges, e) {
        let newEvent = new Slick.EventData();
        $.extend(true, newEvent, e);
        this._ranges = ranges;
        this.onSelectedRangesChanged.notify(this._ranges, newEvent);
    }

    getSelectedRanges() {
        return this._ranges;
    }

    handleActiveCellChange(e, data) {
        if (this._options.selectActiveRow && data.row !== null) {
            this.setSelectedRanges(
                [new Slick.Range(data.row, 0, data.row, this._grid.getColumns().length - 1)],
                {isUserGenerated: true}
            );
        }
    }

    handleKeyDown(e) {
        let activeRow = this._grid.getActiveCell();
        if (
            activeRow &&
            e.shiftKey &&
            !e.ctrlKey &&
            !e.altKey &&
            !e.metaKey &&
            (e.which === 38 || e.which === 40)
        ) {
            let selectedRows = this.getSelectedRows();
            selectedRows.sort(function (x, y) {
                return x - y;
            });

            if (!selectedRows.length) {
                selectedRows = [activeRow.row];
            }

            let top = selectedRows[0];
            let bottom = selectedRows[selectedRows.length - 1];
            let active;

            if (e.which === 40) {
                active = activeRow.row < bottom || top === bottom ? ++bottom : ++top;
            } else {
                active = activeRow.row < bottom ? --bottom : --top;
            }

            if (active >= 0 && active < this._grid.getDataLength()) {
                this._grid.scrollRowIntoView(active);
                this._ranges = this.rowsToRanges(this.getRowsRange(top, bottom));
                this.setSelectedRanges(this._ranges, {isUserGenerated: true});
            }

            e.preventDefault();
            e.stopPropagation();
        }
    }

    handleClick(e) {
        let cell = this._grid.getCellFromEvent(e);

        // Put this on the next tick so the editors have a chance to close out on the click.
        setTimeout(() => {
            if (!cell || !this._grid.canCellBeActive(cell.row, cell.cell)) {
                return false;
            }

            let selection = this.rangesToRows(this._ranges);
            let idx = $.inArray(cell.row, selection);

            if (!this._grid.getOptions().multiSelect || (!e.ctrlKey && !e.shiftKey && !e.metaKey)) {
                selection = [cell.row];
                this._grid.setActiveCell(cell.row, cell.cell);
            } else if (idx === -1 && (e.ctrlKey || e.metaKey)) {
                selection.push(cell.row);
                this._grid.setActiveCell(cell.row, cell.cell);
            } else if (idx !== -1 && (e.ctrlKey || e.metaKey)) {
                selection = $.grep(selection, function (o /*, i*/) {
                    return o !== cell.row;
                });
                this._grid.setActiveCell(cell.row, cell.cell);
            } else if (selection.length && e.shiftKey) {
                let last = selection.pop();
                let from = Math.min(cell.row, last);
                let to = Math.max(cell.row, last);
                selection = [];
                for (let i = from; i <= to; i++) {
                    if (i !== last) {
                        selection.push(i);
                    }
                }
                selection.push(last);
                this._grid.setActiveCell(cell.row, cell.cell);
            }

            this._ranges = this.rowsToRanges(selection);
            this.setSelectedRanges(this._ranges, {isUserGenerated: true});
        });
        return true;
    }
}

module.exports = GridSelectionModel;
